import { Injectable } from '@angular/core';
import { SharedComponent, ShareUserViewModel } from '@dntlab/share-files-dialog';
import { concatMap, firstValueFrom } from 'rxjs';
import { SessionService } from '../auth/session.service';
import { BlockedUsersService } from '../common/services/blocked-users.service';
import { DefaultService as RestApiService } from '../swagger-api';
import { UsersSuggestionBaseService } from './users-suggestion-base.service';

@Injectable({ providedIn: 'root' })
export class UsersSuggestionService extends UsersSuggestionBaseService {
  public constructor(
    apiService: RestApiService,
    private readonly blockedUsers: BlockedUsersService,
    private readonly sessionService: SessionService,
  ) {
    super(apiService);
  }

  public suggestUsers(dialog: SharedComponent, keyword: string): Promise<ShareUserViewModel[]> {
    return this.suggestUsersAsync(dialog, keyword);
  }

  private async suggestUsersAsync(dialog: SharedComponent, keyword: string): Promise<ShareUserViewModel[]> {
    keyword = keyword.trim().toLowerCase();

    if (!keyword) {
      return Promise.resolve<ShareUserViewModel[]>([]);
    }

    return firstValueFrom(
      this.blockedUsers.getBlockedUsersIds().pipe(
        concatMap((blockedUsersIds: string[]) => {
          return super.fetchUsers(dialog, keyword, [...blockedUsersIds, this.sessionService.userId]);
        }),
      ),
    );
  }
}
